// *******************************************************************************
// 1.1 - Product Thumb Slider
// *******************************************************************************

const productSwiperElements = document.querySelectorAll('[data-slider="product-detail-slider"]');
const productSliderThumb = document.querySelectorAll('[data-slider="product-detail-slider-thumb"]');

const productThumbSliderOptions = {
  slidesPerView: 4,
  spaceBetween: 8,
  watchOverflow: true,
  speed: 600,
  observer: true,
};

productSliderThumb.forEach((el) => new Swiper(el, productThumbSliderOptions));

// **********************************************************
// Product detail slider
// **********************************************************

const productSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  loop: true,
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

productSwiperElements.forEach((el, i) => {
  const mainSliderParent = el.closest('.product-detail');
  const arrowRight = mainSliderParent.querySelector('.swiper-button-next');
  const arrowLeft = mainSliderParent.querySelector('.swiper-button-prev');

  productSliderOptions.navigation.nextEl = arrowRight;
  productSliderOptions.navigation.prevEl = arrowLeft;

  productSliderOptions.thumbs.swiper = productSliderThumb[i].swiper;

  new Swiper(el, productSliderOptions);
});

attachEvent('.product-detail__open-filters', 'click', (ev) => {
  ev.target.closest('.product-detail').querySelector('.product-detail__others').classList.add('is-open');
  toggleBodyScrollLock(true);
});

attachEvent('.product-detail__others-close', 'click', (ev) => {
  ev.target.closest('.product-detail__others').classList.remove('is-open');
  toggleBodyScrollLock(false);
});
document.querySelectorAll('.product-detail__header .dropdown__list-item input').forEach((input) => {
  input.addEventListener('click', () => {
    const object = {};
    document.querySelectorAll('.dropdown__list-item input:checked').forEach((checkedInput) => {
      object[checkedInput.name] = checkedInput.value;
    });
    axios
      .post(localData.apiURL, {
        action: 'getVariationData',
        id: localData.id,
        inputs: JSON.stringify(object),
      })
      .then((response) => {
        if (response.data.data.description) {
          document.querySelector('.product-detail__text .editor-text').innerHTML = response.data.data.description;
        }
        if (response.data.data.sku) {
          document.querySelector('.product-detail__code').innerHTML = response.data.data.sku;
        }
        if (response.data.data.thumb) {
          const thumbSrc = response.data.data.thumb;
          const img = document.querySelector(`.product-detail__thumbs img[src="${thumbSrc}"]`);
          if (img?.closest('.swiper-slide')?.parentNode) {
            const slideIndex = [...img.closest('.swiper-slide').parentNode.children].indexOf(
              img.closest('.swiper-slide'),
            );
            document.querySelector('[data-slider="product-detail-slider"]')?.swiper?.slideTo(slideIndex);
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const productDetail = document.querySelector('.sc-product-detail');
  const productData = localData.product;

  if (!productDetail || !productData) {
    return;
  }

  const lastItemClick = localStorage.getItem('last_item_click_classes');
  const productIndex = localStorage.getItem('product_index');

  if (lastItemClick) {
    const item = productData.ecommerce.items[0];
    item.item_list_id = lastItemClick;
    item.item_list_name = localStorage.getItem('item_list_name');
    if (productIndex) {
      item.index = Number(productIndex);
    }

    localData.product_event = {
      item_list_id: lastItemClick || null,
      item_list_name: item?.item_list_name || null,
      index: item?.index ?? null,
    };

    localStorage.removeItem('last_item_click_classes');
    localStorage.removeItem('product_index');
    localStorage.removeItem('item_list_name');
  }
  dataLayerSend([productData]);
});
